import React from 'react'
import { accessibilityColors } from '@edulastic/colors'
import withIconStyles from './HOC/withIconStyles'
import SVG from './common/SVG'

const IconUsers = (props) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12.174 16.005"
    {...props}
  >
    <g transform="translate(0 -38.84)">
      <g transform="translate(0 45.627)">
        <g transform="translate(0 0)">
          <path
            d="M400.633,273.32h1.146a2.981,2.981,0,0,0-.181,1.025v4.331a1.277,1.277,0,0,0,.074.428h-1.895a1.285,1.285,0,0,1-1.284-1.283v-2.361A2.142,2.142,0,0,1,400.633,273.32Z"
            transform="translate(-398.494 -273.32)"
            fill={accessibilityColors.testLibrary.footerIconText}
          />
        </g>
      </g>
      <g transform="translate(11.534 45.627)">
        <g transform="translate(0 0)">
          <path
            d="M.181,274.346A2.981,2.981,0,0,0,0,273.321H1.146a2.142,2.142,0,0,1,2.139,2.139v2.361A1.285,1.285,0,0,1,2,279.1H.107a1.278,1.278,0,0,0,.074-.428Z"
            transform="translate(0 -273.321)"
            fill={accessibilityColors.testLibrary.footerIconText}
          />
        </g>
      </g>
      <g transform="translate(3.96 44.512)">
        <g transform="translate(0 0)">
          <path
            d="M138.968,234.815h2.62a2.142,2.142,0,0,1,2.139,2.139v4.331a.428.428,0,0,1-.428.428h-6.043a.428.428,0,0,1-.428-.428v-4.331A2.142,2.142,0,0,1,138.968,234.815Z"
            transform="translate(-136.829 -234.815)"
            fill={accessibilityColors.testLibrary.footerIconText}
          />
        </g>
      </g>
      <g transform="translate(4.837 38.84)">
        <g transform="translate(0 0)">
          <path
            d="M169.687,38.84a2.572,2.572,0,1,1-2.573,2.573A2.576,2.576,0,0,1,169.687,38.84Z"
            transform="translate(-167.114 -38.84)"
            fill={accessibilityColors.testLibrary.footerIconText}
          />
        </g>
      </g>
      <g transform="translate(10.003 41.238)">
        <g transform="translate(0 0)">
          <path
            d="M35.367,121.689a1.923,1.923,0,1,1-1.924,1.924A1.926,1.926,0,0,1,35.367,121.689Z"
            transform="translate(-33.443 -121.689)"
            fill={accessibilityColors.testLibrary.footerIconText}
          />
        </g>
      </g>
      <g transform="translate(0.968 41.238)">
        <g transform="translate(0 0)">
          <path
            d="M347.531,121.689a1.924,1.924,0,1,1-1.924,1.924A1.926,1.926,0,0,1,347.531,121.689Z"
            transform="translate(-345.607 -121.689)"
            fill={accessibilityColors.testLibrary.footerIconText}
          />
        </g>
      </g>
    </g>
  </SVG>
)

export default withIconStyles(IconUsers)
